/* PAT 7.6 — Geschwindigkeitspaket (Costa, 18.08.2026)
 * Nachbesserung PAT 8.8 (Costa, 04.09.2026): Patrick sah einen Play-Knopf
 * statt eines von selbst laufenden Videos. Ursache: auf Mobil gab es hier
 * gar keinen Autostart-Versuch (nur Desktop per IntersectionObserver) --
 * das Video lief erst nach einem Antippen. Ausserdem zeigte der Knopf sich
 * beim ersten Aufbau kurz von selbst, weil knopfAktualisieren() sofort mit
 * dem noch nicht gestarteten Video (paused=true) lief.
 *
 * Jetzt: der Start-Versuch (IntersectionObserver bzw. sofort, wenn keiner
 * verfuegbar ist) laeuft auf JEDER Bildschirmgroesse, nicht nur Desktop.
 * Das <video> traegt zusaetzlich das native autoplay-Attribut (siehe
 * sections/05-PAT-video-hero-bild.liquid) -- der Browser startet ein
 * stummes, loopendes Video darueber meist schon von sich aus. Der Knopf
 * startet standardmaessig mit dem HTML-Attribut hidden und wird nur noch
 * ueber echte play-/pause-Ereignisse ein- oder ausgeblendet, nicht mehr
 * durch einen sofortigen Check beim Einrichten -- er blitzt also nicht
 * mehr kurz auf und erscheint nur noch, wenn Autoplay wirklich abgelehnt
 * wird, das Video pausiert oder reduzierte Bewegung/Datensparen aktiv ist.
 *
 * Gehoert zu sections/05-PAT-video-hero-bild.liquid (Merkmal
 * data-tp-hero-video am <video>).
 */
(function () {
  'use strict';

  var AUSWAHL = 'video[data-tp-hero-video]';
  var BEWEGUNG = ['pointerdown', 'touchstart', 'keydown'];

  function datenSparen() {
    var verbindung = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!verbindung) return false;
    return verbindung.saveData === true || /(^|-)2g$/.test(verbindung.effectiveType || '');
  }

  function ruhigGestellt() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function knopfFuer(video) {
    if (!video.id) return null;
    return document.querySelector(
      '[data-tp-hero-video-toggle][aria-controls="' + video.id + '"]'
    );
  }

  function knopfAktualisieren(video) {
    var knopf = knopfFuer(video);
    if (!knopf) return;
    var laeuft = !video.paused && !video.ended;
    /* 8.4: Kein Anhalten-Zustand mehr. Der Knopf ist nur sichtbar, solange
       das Video NICHT laeuft, und traegt dann immer "Video abspielen".
       Inline-Style zusaetzlich zu hidden, damit keine CSS-Regel den
       versteckten Knopf wieder einblenden kann. */
    knopf.hidden = laeuft;
    knopf.style.display = laeuft ? 'none' : '';
    var text = 'Video abspielen';
    var label = knopf.querySelector('[data-tp-hero-video-label]');
    knopf.setAttribute('aria-label', text);
    if (label) label.textContent = text;
  }

  function starten(video, bewusst) {
    if (!video || !video.paused) return;
    if (!bewusst && (ruhigGestellt() || datenSparen() || video.dataset.tpBewusstPausiert === '1')) return;
    try {
      video.preload = 'auto';
      video.muted = true;
      var lauf = video.play();
      if (lauf && typeof lauf.catch === 'function') {
        lauf.catch(function () {
          /* Der Browser darf das Abspielen ablehnen. Dann bleibt das
             Posterbild stehen - das ist ein gueltiger Zustand. */
          knopfAktualisieren(video);
        });
      }
    } catch (e) {
      /* bewusst still */
    }
  }

  function bedienungEinrichten(video) {
    if (video.dataset.tpBedienung === '1') return;
    video.dataset.tpBedienung = '1';

    var knopf = knopfFuer(video);
    if (knopf) {
      knopf.addEventListener('click', function () {
        if (video.paused) {
          delete video.dataset.tpBewusstPausiert;
          starten(video, true);
        } else {
          video.dataset.tpBewusstPausiert = '1';
          video.pause();
        }
      });
    }

    video.addEventListener('play', function () { knopfAktualisieren(video); });
    video.addEventListener('pause', function () { knopfAktualisieren(video); });
    /* Nachbesserung 04.09.2026: KEIN sofortiger knopfAktualisieren()-Aufruf
       mehr hier. Das <video> traegt jetzt autoplay + der Knopf startet mit
       dem HTML-Attribut "hidden" (siehe Liquid-Datei) -- er soll nur noch
       auf echte play-/pause-Ereignisse reagieren, nicht auf den Anfangs-
       zustand (paused=true, bevor ueberhaupt ein Startversuch lief). */

    if (typeof window.matchMedia === 'function') {
      var bewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
      var bewegungAendern = function (ereignis) {
        if (ereignis.matches) {
          video.pause();
        } else if (video.dataset.tpBewusstPausiert !== '1') {
          starten(video, false);
        }
      };
      if (typeof bewegung.addEventListener === 'function') {
        bewegung.addEventListener('change', bewegungAendern);
      } else if (typeof bewegung.addListener === 'function') {
        bewegung.addListener(bewegungAendern);
      }
    }
  }

  function scharfMachen() {
    var videos = document.querySelectorAll(AUSWAHL);
    if (!videos.length) return;

    Array.prototype.forEach.call(videos, function (video) {
      bedienungEinrichten(video);

      if (ruhigGestellt() || datenSparen()) {
        video.pause();
        return;
      }

      var los = function () {
        starten(video, false);
      };

      BEWEGUNG.forEach(function (art) {
        window.addEventListener(art, los, { once: true, passive: true });
      });

      /* Nachbesserung 04.09.2026: Der Mobil-Ausschluss ist weg. Vorher lief
         der Start-Versuch nur auf Desktop automatisch, auf Mobil erst nach
         Antippen/Taste -- fuer Patrick sah das wie ein kaputtes Autoplay
         aus. Jetzt versucht JEDE Bildschirmgroesse denselben Weg: sobald
         das Video sichtbar wird (oder sofort, wenn IntersectionObserver
         fehlt). Reduzierte Bewegung und Datensparen (oben in scharfMachen)
         bleiben unveraendert respektiert. */
      if ('IntersectionObserver' in window) {
        var beobachter = new IntersectionObserver(
          function (eintraege) {
            for (var i = 0; i < eintraege.length; i++) {
              if (eintraege[i].isIntersecting) {
                beobachter.disconnect();
                los();
                return;
              }
            }
          },
          { rootMargin: '200px' }
        );
        beobachter.observe(video);
      } else {
        los();
      }
    });
  }

  function anstossen() {
    if (document.readyState === 'complete') {
      setTimeout(scharfMachen, 0);
    } else {
      window.addEventListener('load', function () {
        setTimeout(scharfMachen, 0);
      });
    }
  }

  anstossen();
})();
